/**
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

const generateMarkerContent = (point, gcMapSettings) => {
    let iconHtml = gcMapSettings.iconHtml || '<div style="width: 24px; height: 24px; background-color: {{color}}; border-radius: 50%;"></div>';
    return iconHtml.replace('{{icon}}', point.icon).replace('{{color}}', point.color || '#000000');
};

function loadGoogleMapsAPI(apiKey, callback) {
    // if (document.querySelector(`#google-maps-api-script`)) {
    //     // If the script is already added, no need to add it again
    //     return;
    // }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&loading=async&callback=${callback}`;
    script.id = 'google-maps-api-script';
    script.defer = true; // Defer execution
    document.head.appendChild(script);
}

function deregisterMaps() {
    let maps = document.querySelectorAll('.wp-block-gc-blocks-gc-block-map .inner-contents');

    console.log("gc-blocks/gc-block-map deregisterMaps maps", maps);
    maps.forEach(mapElement => {
        if (mapElement.gcMapInstance) {
            console.log('gc-blocks/gc-block-map deregisterMaps - mapElement.gcMapInstance', mapElement.gcMapInstance);
            // Rimuovi tutti i listener dalla mappa
            google.maps.event.clearInstanceListeners(mapElement.gcMapInstance);
            
            // Rimuovi ogni marcatore associato, se presente
            if (mapElement.gcMarkers) {
                mapElement.gcMarkers.forEach(marker => {
                    google.maps.event.clearInstanceListeners(marker);
                    marker.setMap(null); // Rimuovi il marcatore dalla mappa
                });
                mapElement.gcMarkers = null; // Svuota l'array di marcatori
            }
            
            // Imposta la mappa a null
            mapElement.gcMapInstance = null;
        }

        // Pulisci l'elemento della mappa
        mapElement.innerHTML = '';
    });
}


function initMaps(element = document.body) {
    deregisterMaps();

    let maps = element.querySelectorAll('.wp-block-gc-blocks-gc-block-map');
    console.log("gc-blocks/gc-block-map initMaps maps", maps);
    maps.forEach(map => {
        initMap(map);
    });
}

function parsePointElement(pointElement) {
    let name = pointElement.querySelector('.name')?.textContent;
    let description = pointElement.querySelector('.description')?.textContent;
    let lat = parseFloat(pointElement.querySelector('.latitude')?.textContent);
    let long = parseFloat(pointElement.querySelector('.longitude')?.textContent);
    let icon = pointElement.querySelector('.map-icon-img')?.src;
    let color = pointElement.dataset.color;
    let post_permalink = pointElement.querySelector('.post-link')?.href;
    let post_title = pointElement.querySelector('.post-link')?.textContent;
    return { name, description, lat, long, icon, color, post_permalink, post_title };
}

let currentInfoWindow = null;

async function initMap(mapElement) {

    let gcMapSettings = JSON.parse(mapElement.dataset.gcMapSettings);
    console.log("gc-blocks/gc-block-map initMap gcMapSettings", gcMapSettings);
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const extraMapOptions = JSON.parse(gcMapSettings.options || '{}');
    console.log("gc-blocks/gc-block-map initMap extraMapOptions ", extraMapOptions);
    const mapElementMap = mapElement.querySelector('.inner-contents');
    const mapOptions ={
        mapId: gcMapSettings.googleMapId,
        zoom: gcMapSettings.mapZoom,
        center: { lat: gcMapSettings.mapCenter[0], lng: gcMapSettings.mapCenter[1] },
        mapTypeId: gcMapSettings.mapType,
        ... extraMapOptions
    }
    console.log("gc-blocks/gc-block-map initMap mapOptions", mapOptions);
    const map = new Map(mapElementMap, mapOptions);
    console.log("gc-blocks/gc-block-map initMap map", map);

    let mapPointElements = Array.from(mapElement.querySelectorAll('.map-point'));
    let mapPoints = mapPointElements.map(parsePointElement);

    mapPoints.forEach(point => {
        const iconElement = document.createElement('div');
        iconElement.innerHTML = generateMarkerContent(point, gcMapSettings);

        const marker = new AdvancedMarkerElement({
            map,
            position: { lat: point.lat, lng: point.long },
            content: iconElement.firstChild,
            title: point.name,
        });

        // Create an info window to display on marker click
        const infoWindow = new google.maps.InfoWindow({
            content: `<div class="gc_info_window" style="max-width: 300px;">
                <h2>${point.name}</h2>
                <div id="gc_info_window_content">
                    <p>${point.description}</p>
                    ${point.post_permalink ? `in <a href="${point.post_permalink}" target="_blank">${point.post_title}</a>` : ''}
                </div>
            </div>`,
        });

        marker.addListener('click', () => {
            // Close the current info window if open
            if (currentInfoWindow) {
                currentInfoWindow.close();
            }
            // Open the clicked marker's info window and set it as the current one
            infoWindow.open(map, marker);
            currentInfoWindow = infoWindow;
        });
    });

    // Close info window when clicking outside the map
    map.addListener('click', () => {
        if (currentInfoWindow) {
            currentInfoWindow.close();
            currentInfoWindow = null;
        }
    });
}

function loadMaps() {
    // Check and load Google Maps API if necessary
    if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
        console.log('Loading Google Maps API...');
        const gcMapSettings = JSON.parse(document.querySelector('.wp-block-gc-blocks-gc-block-map').dataset.gcMapSettings);
        window.gcLoadMapsCallback = loadMaps;
        loadGoogleMapsAPI(gcMapSettings.mapApiKey, 'gcLoadMapsCallback');
    } else {
        console.log('Google Maps API already loaded');
        initMaps();
    }
}

document.addEventListener('DOMContentLoaded', loadMaps);
